import { ApexOptions } from "apexcharts";
import ReactApexChart from "react-apexcharts";
import { StockResultSpan1, StockResultSpan2, StockResultSpan3 } from "../../Constant";


export const STOCK_RESULT_LIST =[StockResultSpan1,StockResultSpan2,StockResultSpan3]

const AREA_SPALINE: ApexOptions = {
    series: [
      {
        name: "series1",
        data: [2.57, 2.54, 2.54, 2.56, 2.57, 2.58, 2.59],
      },
    ],
    chart: {
      height: 85,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    yaxis: {
      show: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false, //or just here to disable only x axis grids
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
  
      type: "datetime",
      categories: [
        "2022-09-19T00:00:00.000Z",
        "2022-09-19T01:30:00.000Z",
        "2022-09-19T02:30:00.000Z",
        "2022-09-19T03:30:00.000Z",
        "2022-09-19T04:30:00.000Z",
        "2022-09-19T05:30:00.000Z",
        "2022-09-19T06:30:00.000Z",
      ],
    },
    responsive: [
      {
        breakpoint: 360,
        options: {
          chart: {
            offsetX: -10,
            offsetY: 10,
          },
        },
      },
    ],
    colors: ["#655af3", "#fd2e64"],
  };

  const AREA_SPALINE_2: ApexOptions = {
    series: [
      {
        name: "series1",
        data: [1.12, 1.11, 1.08, 1.08, 1.09, 1.11, 1.08],
      },
    ],
    chart: {
      height: 85,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    yaxis: {
      show: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false, //or just here to disable only x axis grids
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
  
      type: "datetime",
      categories: [
        "2022-09-19T00:00:00.000Z",
        "2022-09-19T01:30:00.000Z",
        "2022-09-19T02:30:00.000Z",
        "2022-09-19T03:30:00.000Z",
        "2022-09-19T04:30:00.000Z",
        "2022-09-19T05:30:00.000Z",
        "2022-09-19T06:30:00.000Z",
      ],
    },
    responsive: [
      {
        breakpoint: 360,
        options: {
          chart: {
            offsetX: -10,
            offsetY: 10,
          },
        },
      },
    ],
    colors: ["#655af3", "#fd2e64"],
  };
  
  const AREA_SPALINE_3: ApexOptions = {
    series: [
      {
        name: "series1",
        data: [3.4, 3.39, 3.46, 3.51, 3.5, 3.48, 3.49],
      },
    ],
    chart: {
      height: 85,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    yaxis: {
      show: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false, //or just here to disable only x axis grids
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
  
      type: "datetime",
      categories: [
        "2022-09-19T00:00:00.000Z",
        "2022-09-19T01:30:00.000Z",
        "2022-09-19T02:30:00.000Z",
        "2022-09-19T03:30:00.000Z",
        "2022-09-19T04:30:00.000Z",
        "2022-09-19T05:30:00.000Z",
        "2022-09-19T06:30:00.000Z",
      ],
    },
    responsive: [
      {
        breakpoint: 360,
        options: {
          chart: {
            offsetX: -10,
            offsetY: 10,
          },
        },
      },
    ],
    colors: ["#655af3", "#fd2e64"],
  };
  
  const AREA_SPALINE_4: ApexOptions = {
    series: [
      {
        name: "series1",
        data: [16.2, 16.4, 16.36, 16.35, 16.61, 16.46, 16.19],
      },
    ],
    chart: {
      height: 85,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    yaxis: {
      show: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false, //or just here to disable only x axis grids
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
  
      type: "datetime",
      categories: [
        "2022-09-19T00:00:00.000Z",
        "2022-09-19T01:30:00.000Z",
        "2022-09-19T02:30:00.000Z",
        "2022-09-19T03:30:00.000Z",
        "2022-09-19T04:30:00.000Z",
        "2022-09-19T05:30:00.000Z",
        "2022-09-19T06:30:00.000Z",
      ],
    },
    responsive: [
      {
        breakpoint: 360,
        options: {
          chart: {
            offsetX: -10,
            offsetY: 10,
          },
        },
      },
    ],
    colors: ["#655af3", "#fd2e64"],
  };
  
  const AREA_SPALINE_5: ApexOptions = {
    series: [
      {
        name: "series1",
        data: [82.51, 83.47, 83.4, 83.68, 83.81, 83.29, 83.72],
      },
    ],
    chart: {
      height: 85,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    yaxis: {
      show: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false, //or just here to disable only x axis grids
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
  
      type: "datetime",
      categories: [
        "2022-09-19T00:00:00.000Z",
        "2022-09-19T01:30:00.000Z",
        "2022-09-19T02:30:00.000Z",
        "2022-09-19T03:30:00.000Z",
        "2022-09-19T04:30:00.000Z",
        "2022-09-19T05:30:00.000Z",
        "2022-09-19T06:30:00.000Z",
      ],
    },
    responsive: [
      {
        breakpoint: 360,
        options: {
          chart: {
            offsetX: -10,
            offsetY: 10,
          },
        },
      },
    ],
    colors: ["#655af3", "#fd2e64"],
  };

export const STOCK_RESULT_DATA = [
    {
      name: "ACME Gadgets",
      symbol: "AGDTS",
      price: "2.57",
      difference: <span style={{ color: "green" }}>0.02</span>,
      last: (
        <ReactApexChart
          options={AREA_SPALINE}
          series={AREA_SPALINE.series}
          height="85"
          type="area"
        />
      ),
    },
    {
      name: "Sole Goodman",
      symbol: "SGMAN",
      price: "16.61",
      difference: <span style={{ color: "green" }}>0.26</span>,
      last: (
        <ReactApexChart
          options={AREA_SPALINE_2}
          series={AREA_SPALINE_2.series}
          height="85"
          type="area"
        />
      ),
    },
    {
      name: "Spry Media Productions",
      symbol: "SPMP",
      price: "1.09",
      difference: <span style={{ color: "green" }}>0.01</span>,
      last: (
        <ReactApexChart
          options={AREA_SPALINE_3}
          series={AREA_SPALINE_3.series}
          height="85"
          type="area"
        />
      ),
    },
    {
      name: "Stanler Bits and Bobs",
      symbol: "SBIBO",
      price: "83.81",
      difference: <span style={{ color: "green" }}>0.13</span>,
      last: (
        <ReactApexChart
          options={AREA_SPALINE_4}
          series={AREA_SPALINE_4.series}
          height="85"
          type="area"
        />
      ),
    },
    {
      name: "Widget Emporium",
      symbol: "WDEMP",
      price: "3.50",
      difference: <span style={{ color: "red" }}>-0.01</span>,
      last: (
        <ReactApexChart
          options={AREA_SPALINE_5}
          series={AREA_SPALINE_5.series}
          height="85"
          type="area"
        />
      ),
    },
  ];

  interface StockResultTableData {
    name: string;
    symbol: string;
    price: string;
    difference: any;
    last: any;
  }

  export const STOCK_RESULT_COLUMN = [
    {
      name: "Name",
      selector: (row:StockResultTableData) => row["name"],
      sortable: true,
      center: false,
    },
    {
      name: "Symbol",
      selector: (row:StockResultTableData) => `${row.symbol}`,
      sortable: true,
      center: false,
    },
    {
      name: "Price",
      selector: (row:StockResultTableData) => `${row.price}`,
      sortable: true,
      center: false,
    },
    {
      name: "Difference",
      cell: (row:StockResultTableData) => row.difference,
      sortable: true,
      center: false,
    },
    {
      name: "Last",
      cell: (row:StockResultTableData) => row.last,
      sortable: true,
      center: false,
    },
  ];